'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var ipfsCore = '0.12.1';
var commit = 'fdc148b5c08c0be49eef77a18259d5baa895e3f9';
var interfaceIpfsCore = '^0.152.1';
exports.commit = commit;
exports.interfaceIpfsCore = interfaceIpfsCore;
exports.ipfsCore = ipfsCore;